import PropTypes from 'prop-types';
import React from 'react';

/**
 * ModuleLayout
 * 
 * Standardized content wrapper for all admin pages.
 * Works inside MainLayout's scrollable content area.
 * The top navbar is handled by MainLayout — this component
 * only wraps the actual page content.
 */
const ModuleLayout = ({ bgClass = "", contentClassName = "", children, ...props }) => {
    return (
        <div className={`${bgClass} flex-1 flex flex-col h-full min-h-0 min-w-0`} {...props}>
            <div className={`flex-1 flex flex-col min-h-0 min-w-0 py-0 md:py-4 lg:py-6 overflow-y-auto scrollbar-premium ${contentClassName}`}>
                <div className="flex-1 flex flex-col px-4 md:px-6 max-w-[1920px] mx-auto w-full">
                    {children}
                </div>
            </div>
        </div>
    );
};

ModuleLayout.propTypes = {
    bgClass: PropTypes.string,
    contentClassName: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default ModuleLayout;
